require('./bootstrap');
require('leaflet');
require('drmonty-leaflet-awesome-markers');

window.Pikaday = require('pikaday');

import Croppie from 'croppie'

